(function(){
  /* date like the source ("October 19th, 2026"): today's date */
  var d=new Date(),m=['January','February','March','April','May','June','July','August','September','October','November','December'][d.getMonth()],n=d.getDate(),
      s=(n%10==1&&n!=11)?'st':(n%10==2&&n!=12)?'nd':(n%10==3&&n!=13)?'rd':'th';
  document.querySelectorAll('[data-adv-date]').forEach(function(e){e.textContent=m+' '+n+s+', '+d.getFullYear();});
  /* sticky CTA appears once the product is introduced (first in-article CTA scrolled past the top) */
  var bar=document.getElementById('adv-sticky'),first=document.querySelector('.adv-main .adv-cta');
  if(!bar||!first)return;
  var on=function(){var r=first.getBoundingClientRect();bar.hidden=!(r.top<0);};
  window.addEventListener('scroll',on,{passive:true});on();
})();
